// extracted by mini-css-extract-plugin
export default {"phaseName":"PhaseName-module__phaseName___dKHVP","icon":"PhaseName-module__icon___bCHCr"};